module.exports = "<div class=\"alerta\"  [ngClass]=\"animation\">\r\n    <alert [type]=\"tipo\"  *ngIf=\"visivel\"\r\n        dismissible=true\r\n        (onClose)=\"onClose($event)\" style=\"width: 315px;\">\r\n        {{mensagem}}\r\n    </alert>\r\n<div>"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/alerta-notificacao/alerta-notificacao.component.html
// module id = ../../../../../src/app/angular-base-ui/alerta-notificacao/alerta-notificacao.component.html
// module chunks = 1